import { usePresence } from "../lib/presence";

// Green "active now" dot overlaid on an avatar; parent must be `relative`.
export const OnlineDot = ({ username, size = 12, className = "" }) => {
  const p = usePresence(username);
  if (!p?.online) return null;
  return (
    <span
      data-testid={`online-dot-${username}`}
      title="Active now"
      style={{ width: size, height: size }}
      className={`absolute bottom-0 right-0 rounded-full bg-[#31A24C] ring-2 ring-[#0A0A0A] shadow-[0_0_8px_rgba(49,162,76,0.8)] ${className}`}
    />
  );
};
